import { useRef } from "react";
import { Button } from "antd";
import { Modal } from "ui";
import { useMagHomeManagementStore } from "pages/mag-home-management/store";
import {
  useAddMagHomeSlider,
  useUpdateMagHomeSlider,
} from "pages/mag-home-management/api";
import SliderForm, { SliderFormRef } from "../form";
import { toast } from "react-toastify";

const SlidersModal = () => {
  const { setFormData, formData, isEdit } = useMagHomeManagementStore(
    (state) => state
  );
  const updateSliderQuery = useUpdateMagHomeSlider();
  const addSliderQuery = useAddMagHomeSlider();
  const loading = isEdit
    ? updateSliderQuery.isPending
    : addSliderQuery.isPending;

  const formRef = useRef<SliderFormRef>(null);

  const handleOk = (onSuccess: () => void) => {
    const values = formRef.current?.getFormData();
    setFormData(values);

    if (isEdit) {
      updateSliderQuery.mutate(
        {
          data: values!,
        },
        {
          onSuccess: () => {
            formRef.current?.resetForm();
            onSuccess();
          },
        }
      );
    } else {
      if (!values?.uploadImage) {
        toast.error("لطفا تصویر اسلایدر را مشخص کنید");
        return;
      }
      addSliderQuery.mutate(
        {
          data: values!,
        },
        {
          onSuccess: () => {
            formRef.current?.resetForm();
            onSuccess();
          },
        }
      );
    }
  };

  return (
    <Modal
      name="MAG_HOME_PAGE_SLIDER_MODAL"
      title={isEdit ? "ویرایش اسلایدر" : "افزودن اسلایدر جدید"}
      okButtonProps={{
        loading: loading,
      }}
      onClose={() => {
        setFormData(undefined);
        formRef.current?.resetForm();
      }}
      footer={(cancel, ok) => (
        <>
          <Button
            onClick={() => {
              cancel();
            }}
          >
            لغو
          </Button>
          <Button
            loading={loading}
            type="primary"
            onClick={() => {
              handleOk(ok);
            }}
          >
            {isEdit ? "ویرایش" : "ثبت"}
          </Button>
        </>
      )}
    >
      <SliderForm ref={formRef} formData={formData} />
    </Modal>
  );
};
export default SlidersModal;
